module.exports = __webpack_public_path__ + "img/card-dog-2.68bbb664.png";